// @ts-nocheck
import styled from 'styled-components';

export const ReportingInsightsRankingItemRawSelectorStyled = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    background-color: inherit;
`;
